import React from 'react';
import { ContactLink } from './HomeUI';
import { PeoplePhoto } from '../people/PeoplePhoto';
import '../people/people.css';

export default function SectionOne() {
  return <section className="home-hero">
    <div className="home-container home-hero-grid">
      <div>
        <p className="home-eyebrow">For businesses & private equity groups</p>
        <h1>Enterprise software.<br /><span>Intelligent automation.</span><br />Built around you.</h1>
        <p className="home-hero-copy">High-quality enterprise software and AI solutions, with end-to-end service tailored to your business. From assessment and planning to development, integration, and ongoing maintenance and support, we bring the right expertise to every stage—or the specific stages you need.</p>
        <div className="home-actions">
          <ContactLink>Discuss your business needs</ContactLink>
          <a className="home-text-link" href="#home-services">Explore our services <span aria-hidden="true">↓</span></a>
        </div>
        <p className="home-hero-note">Enterprise platforms · AI automation · Web & mobile applications</p>
      </div>
      <PeoplePhoto name="collaboration" caption="Good software starts with people working together." eager variant="hero" />
    </div>
  </section>;
}
